import React from "react";

export const LazyFAQPage = React.lazy(() => import("./index"));
